var map = {
	"./app.js": "BfLI",
	"./errorLog.js": "zmvQ",
	"./permission.js": "zhcK",
	"./settings.js": "Cy8W",
	"./tagsView.js": "KiBS",
	"./user.js": "5Ko1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zQ0N";